const TokenKey = 'access_token'
const ExpiresToken = 'expires_in'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  localStorage.setItem(TokenKey, `${token.token_type} ${token.access_token}`)
  localStorage.setItem(ExpiresToken, `${token.expires_in}`)
}

export function removeToken() {
  localStorage.removeItem(ExpiresToken)
  return localStorage.removeItem(TokenKey)
}

// Expires Token
export function getExpiresToken() {
  return localStorage.getItem(ExpiresToken)
}
